import React from "react";
import { Navigate } from "react-router-dom";
import { checkIsLoggedIn } from "../auth/login/Login";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = checkIsLoggedIn();

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
